<h2 mat-dialog-title>{{ tituloTxt }}</h2>
<mat-dialog-content style="min-height: 100px">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="id" value="" />
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Confirmar
  </button>
  <button mat-button mat-flat-button color="primary" mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
